import { jsPDF } from 'jspdf';
import { generateReportHeaderPdf } from './reportHeader';
import { REPORT_TYPE_ORIENTATION, TankplanReportData } from '../ReportGeneratorTypes';
import { getVoyageNumberString } from 'src/utils/stowage/stowageRotationUtils';

/**
 * Generates a PDF report showing the manifold plan details
 * @param doc - jsPDF document instance
 * @param data - Report data containing manifold plan information
 */
export function generateTankplanReport(doc: jsPDF, data: TankplanReportData, firstPage: boolean) {
    if (!firstPage) {
        doc.addPage();
    }

    const fullVoyageNumber = getVoyageNumberString(data.selectedPortCall);

    let _titleText = `${data.headerTitle} ${fullVoyageNumber} ${data.selectedPortCall?.portDisplayName ?? ''}`;

    if (data.selectedBerthCall) {
        _titleText += ` (${data.selectedBerthCall.berthName})`;
    }
    generateReportHeaderPdf(doc, data, _titleText, REPORT_TYPE_ORIENTATION[data.reportType]);

    const pdfWidth = doc.internal.pageSize.getWidth() - 15;
    const pdfHeight = doc.internal.pageSize.getHeight();

    const ratio = Math.min(pdfWidth / data.imgWidth, pdfHeight / data.imgHeight);
    doc.addImage(data.imgData, 'JPEG', 15, 25, data.imgWidth * ratio - 15, data.imgHeight * ratio + 15, undefined, 'FAST');
}
